import { render, staticRenderFns } from "./sales-order-receipts.vue?vue&type=template&id=10db9118&"
import script from "./js/sales-order-receipts.js?vue&type=script&lang=js&"
export * from "./js/sales-order-receipts.js?vue&type=script&lang=js&"
import style0 from "./sales-order-receipts.vue?vue&type=style&index=0&id=10db9118&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports